import { Switch } from 'antd';
import { ReactElement } from 'react';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useTheme } from 'context/ThemeProvider/ThemeProvider';

export const ThemeSwitcher = (): ReactElement => {
  const { theme, toggle } = useTheme();
  return (
    <Switch
      checked={theme === 'dark'}
      checkedChildren={<MoonOutlined />}
      unCheckedChildren={<SunOutlined />}
      onChange={toggle}
    />
  );
};
